var subscriptions = {};

import upgrade_modal from "packs/subscriptions/upgrade_modal.js";
subscriptions.upgrade_modal = upgrade_modal;

import account_plan_modal from "packs/subscriptions/account_plan_modal.js";
subscriptions.account_plan_modal = account_plan_modal;

import premium_website_modal from "packs/subscriptions/premium_website_modal.js";
subscriptions.premium_website_modal = premium_website_modal;

import pricing_table from "packs/subscriptions/pricing_table.js";
subscriptions.pricing_table = pricing_table;

import feature_gates from "packs/subscriptions/feature_gates.js";
subscriptions.feature_gates = feature_gates;

import {
  checkoutAttributionParams,
  trackCheckoutAttribution,
} from "packs/subscriptions/checkout_attribution.js";

document.addEventListener("turbolinks:load", function () {
  if (
    ($("body").attr("data-controller") == "subscriptions" &&
      $("body").attr("data-action") == "plans") ||
    ($("body").attr("data-controller") == "start" &&
      $("body").attr("data-action") == "show") ||
    ($("body").attr("data-controller") == "accounts" &&
      $("body").attr("data-action") == "onboarding")
  ) {
    subscriptions.account_plan_modal(undefined, false);
  }

  if (
    $("body").attr("data-controller") == "subscriptions" &&
    $("body").attr("data-action") == "new"
  ) {
    $("#headingThree")
      .find("a")
      .on("click", function () {
        $(this).hide();
      });

    $("#new_subscription").on("submit", function () {
      if (
        $("body").attr("data-controller") == "subscriptions" &&
        $("body").attr("data-action") == "new"
      ) {
        const params = checkoutAttributionParams($(this), getUrlParameter);
        trackCheckoutAttribution({
          ...params,
          convertflow: window.convertflow,
          dataLayer: window.dataLayer,
        });
      }
    });
  }

  if (
    $("body").attr("data-controller") == "subscriptions" &&
    $("body").attr("data-action") == "index"
  ) {
    $(document).off(
      "click.subscriptionsUsageCollapse",
      ".website-usage-report-row"
    );
    $(document).on(
      "click.subscriptionsUsageCollapse",
      ".website-usage-report-row",
      function (event) {
        const $websiteRow = $(event.currentTarget);
        const websiteCollapseSelector = $websiteRow.attr("data-target");
        const $websiteCollapse = $(websiteCollapseSelector);

        if ($websiteCollapse.length > 0) {
          $websiteCollapse.collapse("toggle");
        }
      }
    );

    $(document).off(
      "shown.bs.collapse.subscriptionsUsageCollapse hidden.bs.collapse.subscriptionsUsageCollapse",
      ".website-usage-report-content"
    );
    $(document).on(
      "shown.bs.collapse.subscriptionsUsageCollapse",
      ".website-usage-report-content",
      function () {
        $(`[data-target="#${this.id}"]`).attr("aria-expanded", "true");
      }
    );
    $(document).on(
      "hidden.bs.collapse.subscriptionsUsageCollapse",
      ".website-usage-report-content",
      function () {
        $(`[data-target="#${this.id}"]`).attr("aria-expanded", "false");
      }
    );

    if (window.location.href.indexOf("modal=true") > -1) {
      $("#upgrade").modal("show");
      subscriptions.pricing_table();
    }

    const websiteId = getUrlParameter("website_id");
    if (websiteId) {
      const $usageModal =
        $('[data-current-month-modal="true"]').first().length > 0
          ? $('[data-current-month-modal="true"]').first()
          : $(".viewsUsageModal").first();

      if ($usageModal.length > 0) {
        const usageModalSelector = `#${$usageModal.attr("id")}`;
        const usageModalWebsiteCollapseSelector = `${usageModalSelector}-website-${websiteId}-sub-reports`;

        $usageModal.one("shown.bs.modal", function () {
          const $websiteCollapse = $(usageModalWebsiteCollapseSelector);
          const $websiteRow = $usageModal.find(
            `[data-target="${usageModalWebsiteCollapseSelector}"]`
          );

          if ($websiteCollapse.length > 0) {
            $websiteCollapse.collapse("show");
          }

          if ($websiteRow.length > 0) {
            $websiteRow[0].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });

        $usageModal.modal("show");
      }
    }
  }

  if (
    $("body").attr("data-controller") == "subscriptions" &&
    $("body").attr("data-action") == "plans"
  ) {
    if (window.location.href.indexOf("annual=true") > -1) {
      $('a[href="#annual"]').trigger("click");
    }
  }

  if ($("body").attr("data-controller") == "start") {
    $('[data-toggle="popover"]').popover();
  }

  subscriptions.feature_gates();
});

export default subscriptions;
